import type { RouteRecordRaw } from 'vue-router'
import { ScheduledRoutes } from '@/routes/user/scheduled/types'
import { AppModule } from '@/config/types'

export const scheduledCompletedRoutes: RouteRecordRaw = {
  name: ScheduledRoutes.completed,
  path: 'completed',
  redirect: { name: ScheduledRoutes.completedOverview },
  component: () => import('@/components/views/scheduled/ScheduledCompleted.vue'),
  children: [
    {
      name: ScheduledRoutes.completedOverview,
      path: '',
      meta: {
        tabTitle: 'pageTabTitle.user.scheduled.completed',
        tags: ['SCHEDULED_BAR_LIST'],
        modules: [AppModule.ScheduledCompleted],
      },
      component: () => import('@/components/views/scheduled/ScheduledCompletedSms.vue'),
    },
    {
      name: ScheduledRoutes.completedOverviewEmail,
      path: 'email',
      meta: {
        tabTitle: 'pageTabTitle.user.scheduled.completedEmail',
        modules: [AppModule.ScheduledEmail, AppModule.Recipient, AppModule.CampaignsSenders],
      },
      component: () => import('@/components/views/scheduled/ScheduledCompletedEmail.vue'),
    },
  ],
}
